import * as React from "react";
function SvgHourglassArrowCross(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      ref={svgRef}
      {...props}
    >
      <circle cx={224.1} cy={71.95} r={31.9} fill="#ed0c51" />
      <path
        d="M242.9 132.35a119.36 119.36 0 11-76.4-111.5"
        fill="none"
        stroke="#ed0c51"
        strokeMiterlimit={10}
        strokeWidth={8}
      />
      <path
        fill="#ed0c51"
        d="M140.5 27.75l19.2-8-8-19.5 11.9 5.2 8 19.1-19.5 8-11.6-4.8z"
      />
      <path
        fill="none"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={7.96}
        d="M212.8 60.35l23.9 23.9M236.7 60.35l-23.9 23.9"
      />
      <path
        d="M163.8 99.45v-19.6H92.1v19.5a18.85 18.85 0 007.6 13.9L128.4 134l-28.7 18.7a15.86 15.86 0 00-7.6 12.7v25.9h71.7v-25.4a14.86 14.86 0 00-6.8-12.7l-28.3-19.1 28.7-20.7a16.38 16.38 0 006.4-13.95z"
        fill="#daebf2"
      />
      <path
        fill="#999"
        d="M183.7 63.95H72.3v4h7.9v11.9h95.6v-11.9h7.9v-4zM175.8 203.35v-12H80.2v12h-7.9v4h111.4v-4h-7.9z"
      />
      <path
        fill="#ffcc10"
        d="M126.8 168.25l33.1 23.1H93.8l33-23.1zM128.8 134.45l-11.2-8h21.9l-10.7 8z"
      />
      <path
        fill="none"
        stroke="#ffcc10"
        strokeMiterlimit={10}
        strokeWidth={3.98}
        strokeDasharray={3.98}
        d="M126.8 138.05v22.3"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgHourglassArrowCross);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
